import {A} from "@solidjs/router";
import {HttpStatusCode} from "@solidjs/start";
import Container from "~/components/Container";

export default function Error() {
    return (
        <Container>
            <HttpStatusCode code={500}/>
            <h1>Error 500: Internal Server Error</h1>
            <A href="/">Home</A>
        </Container>
    )
}